export const ENVIROMENTAL_VARIABLES = {
  API_VERSION: 'v3',
  LEGACY_API_VERSION: 'v2',
  PUBLICBOX_API_VERSION: 'v1',
}
